











import {Component, Vue, Prop} from "vue-property-decorator";
import {ChatMessages} from "../../../../../types/chat-messages";
import {Tool} from "../../../../helpers/Tool";
// @ts-ignore
import store from "../../../../store";

@Component({})

/**
 * Заголовок 2 - важное системное сообщение
 * Кого убили ночью в мафии, Роль игроков в Детектив Клабе
 * В авто играх перед текстом можно загрузить иконку, которая подчеркнет событие
 */
export default class ImportantMessage extends Vue{
    @Prop({required: true}) private readonly message!: ChatMessages.Message;

    /**
     * Собранный текст сообщения
     * @private
     */
    private get messageString(): string
    {
        if (typeof this.message.data.text === 'undefined') {
            return '';
        }
        const replacer = (str: string): any => {
            const playerId = Tool.getStringBetween(str, '#player:', '#');
            return `<span style="color: ${this.getPlayerColorById(playerId)}">${this.getPlayerNameById(playerId)}</span>`
        };
        return this.message.data.text.replace(/#player:.*?#/g, replacer);
    }

    /**
     * Получить имя игрока по ID
     * @param id
     * @private
     */
    private getPlayerNameById(id : string): string
    {
        if (!store.getters.getPlayerGameDataById(id)) {
            return '';
        }
        return store.getters.getPlayerGameDataById(id).name;
    }

    /**
     * Получить цвет игрока по ID
     * @param id
     * @private
     */
    private getPlayerColorById(id: string): string
    {
        if (!store.getters.getPlayerDataById(id)) {
            return '';
        }
        return store.getters.getPlayerDataById(id).color.code;
    }
}
